import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueGtag from 'vue-gtag';

import VueMeta from 'vue-meta';

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css' // Swiper 5 样式
Vue.use(VueAwesomeSwiper)

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import VueMarqueeSlider from 'vue-marquee-slider';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'aos/dist/aos.css';
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueMarqueeSlider);
Vue.use(VueGtag, {
  config: { id: 'G-58SV9E6CR3' }
});

import '/src/assets/scss/main.scss'

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
});
Vue.config.productionTip = false
Vue.use(require('vue-cookies'));

const requireAll = requireContext => requireContext.keys().map(requireContext);
const req = require.context("./assets/img/svg", true, /\.svg$/);
requireAll(req);
import Icon from "@/components/Icon";
// eslint-disable-next-line vue/multi-word-component-names
Vue.component("Icon", Icon);

new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
  },
}).$mount('#app')
